import { useMutation, useQuery } from 'react-query'
import Header from '../../../components/Header'
import { HeadingPages } from '../../../components/HeadingPages'
import { api } from '../../../services/api'
import { useForm } from 'react-hook-form'
import { format } from 'date-fns'
import { Button, Flex, Input, Select, Table, TableContainer, Tbody, Th, Thead, Tr } from '@chakra-ui/react'
import { Loader } from '../../../components/ComponentLoader/Loader'
import { ControleItem } from './ControleItem'
import Axios from 'axios'
import { useEffect, useState } from 'react'
import { formatPrice } from '../../../utils/formatPrice'

export function ControlePagamentos() {
  const { handleSubmit, register } = useForm()
  const [loading, setLoading] = useState(false)

  const { data, isLoading, mutateAsync } = useMutation(['pedidos-pagos'], async (data) => {
    const response = await api.post(`/site/v2/controle-crm/controle-pedidos-pagos`, {
      data_inicio: data.data_inicio,
      data_fim: data.data_fim,
      empresa: data.empresa,
    })

    return response.data
  })

  async function handlePedidosPago(data) {
    console.log(data)
    try {
      await mutateAsync(data)
    } catch (error) {
      console.log(error)
    }
  }

  async function generateExcel() {
    if (!data) return
    if (data.length === 0) return

    setLoading(true)

    const header = ['Numero Unico', 'Numero Pedido', 'Numero Nota', 'Data Pedido', 'Valor Pago', 'Tipo Pagamento', 'Empresa']

    const dataItems = data?.map((item) => {
      return {
        numero_unico: item.numero_unico,
        numero_pedido: item.numero_pedido,
        numero_nota: item.numero_nota,
        data_pedido: format(new Date(item?.data_pedido), 'dd/MM/yyyy HH:mm'),
        valor_pago: formatPrice(item?.valor_pago),
        tipo_pagamento: item?.tipo_pagamento,
        empresa: item?.empresa,
      }
    })

    try {
      const response = await Axios.post(
        'https://apihomolog.innovationbrindes.com.br/node/transform-to-excel',
        {
          header: header,
          data: dataItems,
        },
        { responseType: 'arraybuffer' }
      )

      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })

      const url = window.URL.createObjectURL(blob)

      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `${new Date()}.xlsx`)
      document.body.appendChild(link)
      link.click()
      link.remove()
    } catch (error) {
      console.log(error)
      setLoading(false)
    }

    setLoading(false)
  }

  async function getEmpresas() {
    const response = await api.get('/site/v2/pedido/lista-empresas')

    return response.data
  }

  const { data: empresas } = useQuery({
    queryKey: 'empresas',
    queryFn: getEmpresas,
    staleTime: 1000 * 60 * 60 * 24,
    refetchOnWindowFocus: false,
  })

  useEffect(() => {
    handlePedidosPago({
      data_inicio: '',
      data_fim: '',
      empresa: '',
    })
  }, [])

  return (
    <>
      <HeadingPages name="Controle de Pagamentos" />

      {isLoading && <Loader />}

      <Flex as="form" alignItems="center" gap={2} w="100%" maxW={1480} mx="auto" px="6" mt={3}>
        <Input type="date" {...register('data_inicio')} />
        <Input type="date" {...register('data_fim')} />
        <Select {...register('empresa')}>
          <option value="">Todas as empresas</option>
          {empresas?.map((empresa) => (
            <option key={empresa.codigo_empresa} value={empresa.codigo_empresa}>
              {empresa.nome_empresa}
            </option>
          ))}
        </Select>
        <Button
          onClick={handleSubmit(handlePedidosPago)}
          backgroundColor="green.500"
          color="white"
          _hover={{
            filter: 'brightness(0.9)',
          }}
          maxW="200px"
          w="full"
        >
          Buscar
        </Button>
      </Flex>

      <Flex as="form" w="100%" maxW={1480} mx="auto" px="6" align="center" flexDir="column">
        <Flex alignItems="center" justifyContent="center" w="full" mt="1rem" gap="1rem">
          {data && (
            <Button
              onClick={generateExcel}
              backgroundColor="green.500"
              color="white"
              _hover={{
                filter: 'brightness(0.9)',
              }}
              isLoading={loading}
              maxW="200px"
              w="full"
              loadingText="Gerando excel"
            >
              Gerar Excel
            </Button>
          )}
        </Flex>

        {!isLoading && (
          <TableContainer
            maxW="1480px"
            w="full"
            mt="1rem"
            size="sm"
            maxH="500px"
            overflowY="scroll"
            boxShadow="md"
            borderRadius="md"
            border="1px solid #e2e8f0"
          >
            <Table variant="simple">
              <Thead position="sticky" top="0" bg="#E2E8F0">
                <Tr>
                  <Th>Numero Unico</Th>
                  <Th>Numero Pedido</Th>
                  <Th>Numero Nota</Th>
                  <Th>Data Pedido</Th>
                  <Th>Valor Pago</Th>
                  <Th>Tipo Pagamento</Th>
                  <Th>Empresa</Th>
                </Tr>
              </Thead>
              <Tbody>
                {data?.map((item, index) => (
                  <ControleItem key={index} item={item} />
                ))}
              </Tbody>
            </Table>
          </TableContainer>
        )}
      </Flex>
    </>
  )
}
